export default "__VITE_ASSET__CvEEu7JY__"